/* ============================================================
   Sand & Splash Station — Interactive JS
   File: assets/sand-splash.js
   Upload to: Shopify Admin → Online Store → Themes → Edit code → assets/
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── IMAGE GALLERY ──────────────────────────────────────────
  const galleryImages = document.querySelectorAll('.ss-gallery-main img');
  const galleryThumbs = document.querySelectorAll('.ss-gallery-thumb');

  function activateGalleryImage(index) {
    galleryImages.forEach((img, i) => img.classList.toggle('active', i === index));
    galleryThumbs.forEach((th, i) => th.classList.toggle('active', i === index));
  }

  galleryThumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => activateGalleryImage(index));
  });

  // ── STICKY BAR ─────────────────────────────────────────────
  const stickyBar = document.getElementById('ss-sticky-bar');
  const purchasePanel = document.getElementById('ss-purchase-panel');

  if (stickyBar && purchasePanel) {
    const observer = new IntersectionObserver(
      ([entry]) => stickyBar.classList.toggle('visible', !entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(purchasePanel);
  }

  // ── QUANTITY SELECTOR ──────────────────────────────────────
  const qtyDisplay = document.getElementById('ss-qty-display');
  const qtyInput = document.getElementById('ss-qty-input');
  const qtyBtns = document.querySelectorAll('.ss-qty-btn');

  qtyBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      let val = parseInt(qtyDisplay.textContent) || 1;
      if (btn.dataset.action === 'plus') val++;
      if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
      qtyDisplay.textContent = val;
      if (qtyInput) qtyInput.value = val;
    });
  });

  // ── DELIVERY DATE (14 days from today) ─────────────────────
  const deliveryEl = document.getElementById('ss-delivery-date');
  if (deliveryEl) {
    const d = new Date();
    d.setDate(d.getDate() + 35);
    deliveryEl.textContent = d.toLocaleDateString('en-AU', {
      weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
    });
  }

  // ── FAQ ACCORDION ──────────────────────────────────────────
  document.querySelectorAll('.ss-faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const answer = btn.nextElementSibling;
      const chevron = btn.querySelector('.ss-faq-chevron');
      const isOpen = answer.classList.contains('open');
      answer.classList.toggle('open', !isOpen);
      if (chevron) chevron.classList.toggle('open', !isOpen);
    });
  });

  // ── REVIEW CAROUSEL ────────────────────────────────────────
  const reviews = [
    { stars: 5, text: "This set has transformed our backyard. The kids spend hours out there every single day. Build quality is exceptional — we've had it through two wet seasons and it looks brand new.", author: "Sarah M.", location: "Brisbane, QLD", date: "March 2025", verified: true },
    { stars: 5, text: "We bought this for our childcare centre and it's been the most popular outdoor activity we've introduced. Durable, safe and genuinely educational. Parents love it too.", author: "Lisa T.", location: "Melbourne, VIC", date: "January 2025", verified: true },
    { stars: 5, text: "Assembly was genuinely easy — I had it set up in about 20 minutes on my own. The HDPE surface is really smooth and easy to clean. Worth every cent.", author: "David K.", location: "Sydney, NSW", date: "February 2025", verified: true },
    { stars: 5, text: "My three kids (ages 2, 4 and 7) all use this together and it keeps them entertained for hours. The stools are the perfect height and everything feels incredibly well made.", author: "Jess & Tom R.", location: "Perth, WA", date: "December 2024", verified: true },
    { stars: 4, text: "Great product overall — the kids absolutely love it. Took about 25 minutes to assemble but the instructions were clear. Would love a cover accessory to protect it overnight.", author: "Michael B.", location: "Adelaide, SA", date: "November 2024", verified: true },
    { stars: 5, text: "We run a family day care and this has been a game changer. It encourages cooperative play between children of all ages and is really easy to hose down at the end of the day.", author: "Natalie W.", location: "Gold Coast, QLD", date: "October 2024", verified: true },
    { stars: 5, text: "Bought this as a birthday gift — the reaction when we set it up was priceless. The quality is far above anything else I looked at and the Made in Australia badge really matters to me.", author: "Karen S.", location: "Hobart, TAS", date: "September 2024", verified: true },
    { stars: 5, text: "Our occupational therapist actually recommended a product like this for our daughter's sensory needs. She uses it daily and her engagement and focus have noticeably improved.", author: "Emma & Liam F.", location: "Canberra, ACT", date: "August 2024", verified: true },
    { stars: 4, text: "Solid product that looks exactly as pictured. Delivery was fast and well packed. The powder-coated frame hasn't shown any rust after leaving it outside all summer.", author: "Craig H.", location: "Newcastle, NSW", date: "July 2024", verified: true },
  ];

  const VISIBLE = 3;
  let currentIdx = 0;
  const reviewGrid = document.getElementById('ss-reviews-grid');
  const dotsContainer = document.getElementById('ss-carousel-dots');

  function renderReviews() {
    if (!reviewGrid) return;
    reviewGrid.innerHTML = '';
    for (let i = 0; i < VISIBLE; i++) {
      const r = reviews[(currentIdx + i) % reviews.length];
      const stars = '★'.repeat(r.stars) + '☆'.repeat(5 - r.stars);
      reviewGrid.innerHTML += `
        <div class="ss-review-card">
          <div class="ss-review-stars">${stars}</div>
          <p class="ss-review-text">"${r.text}"</p>
          <div class="ss-review-author">${r.author} · ${r.location}</div>
          <div class="ss-review-date">${r.date}${r.verified ? ' <span class="ss-review-verified">✓ Verified Purchase</span>' : ''}</div>
        </div>`;
    }
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      reviews.forEach((_, i) => {
        const dot = document.createElement('div');
        dot.className = 'ss-carousel-dot' + (i === currentIdx ? ' active' : '');
        dot.addEventListener('click', () => goTo(i));
        dotsContainer.appendChild(dot);
      });
    }
  }

  function goTo(idx) {
    if (!reviewGrid) return;
    reviewGrid.classList.add('animating');
    setTimeout(() => {
      currentIdx = (idx + reviews.length) % reviews.length;
      renderReviews();
      reviewGrid.classList.remove('animating');
    }, 300);
  }

  document.getElementById('ss-carousel-prev')?.addEventListener('click', () => goTo(currentIdx - 1));
  document.getElementById('ss-carousel-next')?.addEventListener('click', () => goTo(currentIdx + 1));
  renderReviews();

  // ── ENQUIRY PANEL ──────────────────────────────────────────
  function openEnquiry() {
    document.getElementById('ss-enquiry-panel')?.classList.add('open');
    document.getElementById('ss-enquiry-overlay')?.classList.add('open');
  }
  function closeEnquiry() {
    document.getElementById('ss-enquiry-panel')?.classList.remove('open');
    document.getElementById('ss-enquiry-overlay')?.classList.remove('open');
  }

  document.getElementById('ss-enquiry-tab')?.addEventListener('click', openEnquiry);
  document.getElementById('ss-enquiry-close')?.addEventListener('click', closeEnquiry);
  document.getElementById('ss-enquiry-overlay')?.addEventListener('click', closeEnquiry);
  document.getElementById('ss-enquiry-btn')?.addEventListener('click', openEnquiry);



  // ── VARIANT SELECTOR → UPDATE PRICE ───────────────────────
  const variantSelect = document.querySelector('.ss-variant-select');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const variantId = this.value;
      const hiddenInput = document.querySelector('input[name="id"]');
      if (hiddenInput) hiddenInput.value = variantId;
      // Shopify theme's cart JS handles price update if you dispatch an event
      this.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

});
